import React from 'react';
import UserInfo from '../../Components/User/UserInfo';
import telegram from '../../assets/img/social/telegram.svg';
import face from '../../assets/img/social/face.svg';
import inst from '../../assets/img/social/inst.svg';
import TopTitleBlock from '../../Components/TopTitleBlock/TopTitleBlock';
import {Form, Formik} from 'formik';
import {UserInfoEditType} from '../../types/TypesUser';
import {
	useGetUserInfoQuery,
	useEditUserInfoMutation,
} from '../../redux/userApi';
import {useTranslation} from 'react-i18next';
import {CustomInput} from '../../Components/Input';
import CustomSelect, {BaseOption} from '../../Components/Select/CustomSelect';
import SelectSvgSelector from '../../Components/InputSelect/SelectSvgSelector';
import CalendarField from '../RegistrationNewClient/components/CalendarField';
import {handleApiCallWithFullError} from '../../assets/utils/utils';
import {toast} from 'react-toastify';
import UpdatePassword from './components/UpdatePassword';
import s from './PersonalInfoUpdate.module.css';

const PersonalInfoUpdate: React.FC = () => {
	const {t} = useTranslation();
	const {data: userInfoData} = useGetUserInfoQuery();
	const [editUserInfo] = useEditUserInfoMutation();

	const initialValues: UserInfoEditType = {
		new_surname: userInfoData?.surname ?? '',
		new_birth_date: userInfoData?.birth_date ?? '',
		new_contract: userInfoData?.contract ?? '',
		new_email: userInfoData?.email ?? '',
		new_gender: userInfoData?.gender ?? '',
		new_mail_region: userInfoData?.mail_region ?? '',
		new_fb: userInfoData?.fb ?? '',
		new_instagram: userInfoData?.instagram ?? '',
		new_mail_address: userInfoData?.mail_address ?? '',
		new_mail_city: userInfoData?.mail_city ?? '',
		new_mail_state: userInfoData?.mail_state ?? '',
		new_tg: userInfoData?.tg ?? '',
		new_middlename: userInfoData?.middlename ?? '',
		new_name: userInfoData?.name ?? '',
		new_viber: userInfoData?.viber ?? '',
		new_password: '',
		new_phone: userInfoData?.contract ?? '',
	};
	const handleSubmit = async (values: UserInfoEditType) => {
		// Преобразуем данные для отправки: new_phone отправляется как new_phone в API
		const submitData = {
			...values,
			new_phone: values.new_phone,
		};
		// Удаляем new_contract из отправляемых данных, так как используем new_phone
		const {new_contract, ...dataToSend} = submitData;
		await handleApiCallWithFullError({
			apiCall: () => editUserInfo(dataToSend),
			onSuccess: (data) => toast.success(data.message.textmsg),
		});
	};

	return (
		<div className="page__content">
			<TopTitleBlock title={t('Особистий профіль')} />
			<div className="page__user-profile user-profile">
				<div className="user__column">
					<UserInfo />
				</div>
			</div>
			<Formik
				initialValues={initialValues}
				onSubmit={handleSubmit}
				enableReinitialize
			>
				{({values, handleSubmit, setFieldValue}) => {
					return (
						<Form
							id={'info-edit'}
							onSubmit={handleSubmit}
							className={s.information}
						>
							<div className={s.informationTitle}>
								{t('Щоб змінити, введіть необхідні дані')}
							</div>
							<div className={s.mainInformation}>
								<div className={s.labelInformation}>
									{t('Основна інформація')}
								</div>
								<div className={s.mainInformationRow}>
									<div className={s.mainInformationColumn}>
										<div className={`${s.mainInformationItem} ${s.itemInfo}`}>
											<CustomInput
												name="new_surname"
												placeholder={t('Прізвище')}
												icon={<SelectSvgSelector id={'nameIcon'} />}
											/>
										</div>
										<div className={`${s.mainInformationItem} ${s.itemInfo}`}>
											<CustomInput
												name="new_name"
												placeholder={t("Ім'я")}
												icon={<SelectSvgSelector id={'nameIcon'} />}
											/>
										</div>
										<div className={`${s.mainInformationItem} ${s.itemInfo}`}>
											<CustomInput
												name="new_middlename"
												placeholder={t('По батькові')}
												icon={<SelectSvgSelector id={'nameIcon'} />}
											/>
										</div>
									</div>
									<div className={s.mainInformationColumn}>
										<div className={`${s.mainInformationItem} ${s.itemInfo}`}>
											<CustomSelect
												name="new_gender"
												placeholder={t('Стать')}
												options={
													[
														{label: t('Чоловіча'), value: 'M'},
														{label: t('Жіноча'), value: 'F'},
													] as BaseOption[]
												}
												value={
													(
														[
															{label: t('Чоловіча'), value: 'M'},
															{label: t('Жіноча'), value: 'F'},
														] as BaseOption[]
													).find((o) => o.value === values.new_gender) || null
												}
												onChange={(opt: BaseOption | null) =>
													setFieldValue('new_gender', opt?.value || '')
												}
											/>
										</div>
										<div className={`${s.mainInformationItem} ${s.itemInfo}`}>
											<CalendarField
												name="new_birth_date"
												placeholder={t('Дата народження')}
											/>
										</div>
										<div className={`${s.mainInformationItem} ${s.itemInfo}`}>
											<CustomInput
												name="new_email"
												type="email"
												placeholder={t('Електронна пошта')}
												icon={<SelectSvgSelector id={'email'} />}
											/>
										</div>
									</div>
								</div>
							</div>

							<div className={s.address}>
								<div className={s.labelInformation}>
									{t('Країна')}
								</div>
								<div className={s.addressRow}>
									<div className={s.addressColumn}>
										<div className={s.itemInfo}>
											<CustomInput
												name="new_mail_state"
												placeholder={t('Країна')}
											/>
										</div>
										<div className={s.itemInfo}>
											<CustomInput
												name="new_mail_region"
												placeholder={t('Область')}
											/>
										</div>
									</div>
									<div className={s.addressColumn}>
										<div className={s.itemInfo}>
											<CustomInput
												name="new_mail_city"
												placeholder={t('Місто')}
											/>
										</div>
										<div className={s.itemInfo}>
											<CustomInput
												name="new_mail_address"
												placeholder={t('Адреса')}
											/>
										</div>
									</div>
								</div>
							</div>

							<div className={s.socialLinks}>
								<div className={s.labelInformation}>
									{t('Посилання на соціальні мережі')}
								</div>
								<div className={s.socialLinksRow}>
									<div className={s.socialLinksLink}>
										<img src={telegram} alt="telegram" />
									</div>
									<div className={`${s.socialLinksItem} ${s.itemInfo}`}>
										<CustomInput
											name="new_tg"
											placeholder={t('Введіть посилання')}
										/>
									</div>
								</div>
								<div className={s.socialLinksRow}>
									<div className={s.socialLinksLink}>
										<img src={inst} alt="instagram" />
									</div>
									<div className={`${s.socialLinksItem} ${s.itemInfo}`}>
										<CustomInput
											name="new_instagram"
											placeholder={t('Введіть посилання')}
										/>
									</div>
								</div>
								<div className={s.socialLinksRow}>
									<div className={s.socialLinksLink}>
										<img src={face} alt="facebook" />
									</div>
									<div className={`${s.socialLinksItem} ${s.itemInfo}`}>
										<CustomInput
											name="new_fb"
											placeholder={t('Введіть посилання')}
										/>
									</div>
								</div>
							</div>

							<div className={s.phoneContact}>
								<div className={s.labelInformation}>
									{t('Телефон для контактів')}
								</div>
								<div className={`${s.phoneContactItem} ${s.itemInfo}`}>
									<CustomInput
										name="new_phone"
										placeholder={t('Телефон')}
										type="tel"
										autoComplete="username"
										icon={<SelectSvgSelector id={'phone'} />}
									/>
								</div>
							</div>

							<button className={`${s.informationBtn} btn-main`}>
								{t('ЗБЕРЕГТИ ЗМІНИ')}
							</button>

							<UpdatePassword />
						</Form>
					);
				}}
			</Formik>
		</div>
	);
};

export default PersonalInfoUpdate;
